/*
 * Copyright (c) Nexign, JSC, 2025.
 */

/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

export enum EFastActionsButtonTypes {
    INQUIRY_CREATE  = 'INQUIRY_CREATE',
    BILL_INVOICE  = 'BILL_INVOICE',
    REPORT_DOCUMENTS  = 'REPORT_DOCUMENTS',
    ADVANCE_INVOICE  = 'ADVANCE_INVOICE',
    PROMISED_PAYMENTS  = 'PROMISED_PAYMENTS',
    SUBSCRIBERS_IN_ROAMING   = 'SUBSCRIBERS_IN_ROAMING',
}

export const maxVisibleButtonsOnPlate = 5;
